export default [
    {
      path: '/admin/reports/finances/income-statement-details',
      name: 'income-statement-detail',
      meta: { requiresAuth: true },
      component: () => import('@/pages/report/finance/income-statement-detail.vue')
    }
  ]
